import Swiper, { Autoplay} from 'swiper';
import { atQuery } from '../components/mediaQueries';
Swiper.use([Autoplay]);

/**
 * Create Carousel
 *
 * @param {Array} carouselArray
 * @param {string} instanceName
 * @param {Array} swiperMultiCarouselArray
 * @param {Object} options
 */
const createCarousel = ( carouselArray, instanceName, swiperMultiCarouselArray, options ) => {

    $.each(carouselArray, (index) => {

        var $parent = $(instanceName).eq(index).parents('.shopify-section');
        var multiCarousel = new Swiper("#" + $parent.attr('id') + " " + instanceName, options);
        swiperMultiCarouselArray.push(multiCarousel);

        $parent.find(
            '.fake-controls__arrows > span,' +
            '.fake-controls__counter > span,' +
            '.fake-controls__pagination .pagination__fill'
        ).attr('data-swiper', index);

    });

};

const destroyCarousel = ( swiperMultiCarouselArray ) => {
    $.each(swiperMultiCarouselArray, (key) => {
        swiperMultiCarouselArray[key].destroy();
    })
    swiperMultiCarouselArray.splice(0, swiperMultiCarouselArray.length);
};

$(document).on('ready', function() {

    var swiperMultiCarouselArray = [], $fakePrev, $fakeNext;

    $fakePrev = $('.fake-controls__prev');
    $fakeNext = $('.fake-controls__next');

    const carouselArray = Array.from(
        document.querySelectorAll( '.shopify-section > .multi-carousel' )
    );

    const multiCarouselOption = {
        slidesPerView: 1,
        loop: false,
        autoplay: {
            enabled: false,
            disableOnInteraction: true
        }
    }

    const multiCarouselAutoplayOption = {
        slidesPerView: 1,
        loop: false,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        }
    }

    $fakePrev.on('click', function() {
        var index = $(this).attr('data-swiper');
        swiperMultiCarouselArray[index].slidePrev();
    });

    $fakeNext.on('click', function() {
        var index = $(this).attr('data-swiper');
        swiperMultiCarouselArray[index].slideNext();
    });

    atQuery('max', 'xl', ()=>{

        swiperMultiCarouselArray.length > 0 ?
            destroyCarousel(swiperMultiCarouselArray)
        : null;

        createCarousel(
            carouselArray,
            ".multi-carousel__wrapper.swiper",
            swiperMultiCarouselArray,
            multiCarouselAutoplayOption
        );

    })

    atQuery('min', 'xl', ()=>{

        swiperMultiCarouselArray.length > 0 ?
            destroyCarousel(swiperMultiCarouselArray)
        : null;

        createCarousel(
            carouselArray,
            ".multi-carousel__wrapper.swiper",
            swiperMultiCarouselArray,
            multiCarouselOption
        );

        swiperMultiCarouselArray.length > 0 ?
            $.each(swiperMultiCarouselArray, (key) => {

                this.swiper = swiperMultiCarouselArray[key];
                var slideCounter = this.swiper.slides ? this.swiper.slides.length : null;
                var paginationProgress = 100 / slideCounter;

                $(".fake-counter__total[data-swiper="+ key +"]").text(slideCounter);
                $(".fake-counter__progress[data-swiper="+ key +"]").text(this.swiper.activeIndex + 1);
                $(".pagination__fill[data-swiper="+ key +"]").css('width', paginationProgress + '%');

                this.swiper.on('slideChange', (swiper) => {

                    let $currentParentId = $(swiper.params.el.split(" ")[0]);
                    let slideIndex = swiper.activeIndex + 1;
                    let fillPercentage = paginationProgress * slideIndex;

                    $currentParentId.find(".fake-counter__progress").text(slideIndex);
                    $currentParentId.find(".fake-controls__pagination .pagination__fill").css('width', fillPercentage + '%');

                })
            })
        : null;

    })

});







